import SimilarReportsScreen from '@screens/SimilarReports/SimilarReportsScreen';

export default SimilarReportsScreen;
